var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"4"}},[_c('div',{staticClass:"list"},[_vm._v("\n        "+_vm._s(_vm.myRelations.filter(function (r) { return r.roleId == _vm.relationType.id; }).map(function (r) { return r.name; }).join(' | '))+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f63bd54","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/public_app/pages/feedback/FeedbackViewRelations.vue
// module id = null
// module chunks = 